import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { FinancialMediationForm } from "../components/forms/FinancialMediationForm";

const FinancialMediationCreateContainer = () => {
  return (
    <ContentWrapper>
      <FinancialMediationForm />
    </ContentWrapper>
  );
};

export default FinancialMediationCreateContainer;
